module.exports = __webpack_public_path__ + "img/swatch-IMG_2581.857ced75.png";